__turbopack_context__.v({
  "aboutCopy": "marketing-home-module__q7Au8W__aboutCopy",
  "aboutCta": "marketing-home-module__q7Au8W__aboutCta",
  "aboutGrid": "marketing-home-module__q7Au8W__aboutGrid",
  "aboutInner": "marketing-home-module__q7Au8W__aboutInner",
  "aboutPillars": "marketing-home-module__q7Au8W__aboutPillars",
  "aboutSection": "marketing-home-module__q7Au8W__aboutSection",
  "activeNavItem": "marketing-home-module__q7Au8W__activeNavItem",
  "anchorTarget": "marketing-home-module__q7Au8W__anchorTarget",
  "badge": "marketing-home-module__q7Au8W__badge",
  "benefits": "marketing-home-module__q7Au8W__benefits",
  "brand": "marketing-home-module__q7Au8W__brand",
  "browserBar": "marketing-home-module__q7Au8W__browserBar",
  "builder": "marketing-home-module__q7Au8W__builder",
  "checked": "marketing-home-module__q7Au8W__checked",
  "completion": "marketing-home-module__q7Au8W__completion",
  "copyright": "marketing-home-module__q7Au8W__copyright",
  "ctas": "marketing-home-module__q7Au8W__ctas",
  "demoButton": "marketing-home-module__q7Au8W__demoButton",
  "demoCopy": "marketing-home-module__q7Au8W__demoCopy",
  "demoError": "marketing-home-module__q7Au8W__demoError",
  "demoField": "marketing-home-module__q7Au8W__demoField",
  "demoForm": "marketing-home-module__q7Au8W__demoForm",
  "demoInner": "marketing-home-module__q7Au8W__demoInner",
  "demoSection": "marketing-home-module__q7Au8W__demoSection",
  "demoSubmit": "marketing-home-module__q7Au8W__demoSubmit",
  "demoSuccess": "marketing-home-module__q7Au8W__demoSuccess",
  "description": "marketing-home-module__q7Au8W__description",
  "downloadButton": "marketing-home-module__q7Au8W__downloadButton",
  "featureCard": "marketing-home-module__q7Au8W__featureCard",
  "featureGrid": "marketing-home-module__q7Au8W__featureGrid",
  "featureIcon": "marketing-home-module__q7Au8W__featureIcon",
  "featureMeta": "marketing-home-module__q7Au8W__featureMeta",
  "featureNumber": "marketing-home-module__q7Au8W__featureNumber",
  "featuresEyebrow": "marketing-home-module__q7Au8W__featuresEyebrow",
  "featuresInner": "marketing-home-module__q7Au8W__featuresInner",
  "featuresSection": "marketing-home-module__q7Au8W__featuresSection",
  "fieldHeading": "marketing-home-module__q7Au8W__fieldHeading",
  "footer": "marketing-home-module__q7Au8W__footer",
  "footerBrand": "marketing-home-module__q7Au8W__footerBrand",
  "footerGroup": "marketing-home-module__q7Au8W__footerGroup",
  "footerInner": "marketing-home-module__q7Au8W__footerInner",
  "genericPreview": "marketing-home-module__q7Au8W__genericPreview",
  "genericPreviewBody": "marketing-home-module__q7Au8W__genericPreviewBody",
  "genericPreviewHeader": "marketing-home-module__q7Au8W__genericPreviewHeader",
  "header": "marketing-home-module__q7Au8W__header",
  "hero": "marketing-home-module__q7Au8W__hero",
  "heroCopy": "marketing-home-module__q7Au8W__heroCopy",
  "heroInner": "marketing-home-module__q7Au8W__heroInner",
  "hosting": "marketing-home-module__q7Au8W__hosting",
  "jobField": "marketing-home-module__q7Au8W__jobField",
  "jobSeekerHeading": "marketing-home-module__q7Au8W__jobSeekerHeading",
  "jobSeekerInner": "marketing-home-module__q7Au8W__jobSeekerInner",
  "jobSeekerSection": "marketing-home-module__q7Au8W__jobSeekerSection",
  "jobSeekerSteps": "marketing-home-module__q7Au8W__jobSeekerSteps",
  "localeSwitch": "marketing-home-module__q7Au8W__localeSwitch",
  "logo": "marketing-home-module__q7Au8W__logo",
  "mockup": "marketing-home-module__q7Au8W__mockup",
  "mockupFooter": "marketing-home-module__q7Au8W__mockupFooter",
  "nav": "marketing-home-module__q7Au8W__nav",
  "navActions": "marketing-home-module__q7Au8W__navActions",
  "navLinks": "marketing-home-module__q7Au8W__navLinks",
  "page": "marketing-home-module__q7Au8W__page",
  "previewIcon": "marketing-home-module__q7Au8W__previewIcon",
  "pricingOption": "marketing-home-module__q7Au8W__pricingOption",
  "pricingTeaser": "marketing-home-module__q7Au8W__pricingTeaser",
  "pricingTeaserInner": "marketing-home-module__q7Au8W__pricingTeaserInner",
  "pricingTeaserLink": "marketing-home-module__q7Au8W__pricingTeaserLink",
  "primaryCta": "marketing-home-module__q7Au8W__primaryCta",
  "resumePreviewEntry": "marketing-home-module__q7Au8W__resumePreviewEntry",
  "resumePreviewMeta": "marketing-home-module__q7Au8W__resumePreviewMeta",
  "resumePreviewSection": "marketing-home-module__q7Au8W__resumePreviewSection",
  "secondaryCta": "marketing-home-module__q7Au8W__secondaryCta",
  "sidebar": "marketing-home-module__q7Au8W__sidebar",
  "sidebarLabel": "marketing-home-module__q7Au8W__sidebarLabel",
  "suggestion": "marketing-home-module__q7Au8W__suggestion",
  "suggestions": "marketing-home-module__q7Au8W__suggestions",
  "summaryCard": "marketing-home-module__q7Au8W__summaryCard",
  "summaryCards": "marketing-home-module__q7Au8W__summaryCards",
  "themeCanvas": "marketing-home-module__q7Au8W__themeCanvas",
  "themePreview": "marketing-home-module__q7Au8W__themePreview",
  "themeSwatches": "marketing-home-module__q7Au8W__themeSwatches",
  "themeToolbar": "marketing-home-module__q7Au8W__themeToolbar",
  "whiteLabelCopy": "marketing-home-module__q7Au8W__whiteLabelCopy",
  "whiteLabelCta": "marketing-home-module__q7Au8W__whiteLabelCta",
  "whiteLabelEyebrow": "marketing-home-module__q7Au8W__whiteLabelEyebrow",
  "whiteLabelInner": "marketing-home-module__q7Au8W__whiteLabelInner",
  "whiteLabelSection": "marketing-home-module__q7Au8W__whiteLabelSection",
  "workspace": "marketing-home-module__q7Au8W__workspace",
});
